
<dynamic-fields-menu>
  <template #header>
    <input v-model="q" type="text" placeholder="Search">
  </template>
  <template #body>
    <scroll-area class="dynamic-box">
      <hr>
      <div v-for="input in certificateDynamicInputs">
        <button
          class="field-item"
          v-if="input.type === CertificateDynamicInputType.Text"
          type="button"
          @click="select({id: input.client_id, additionalClasses: additionalClasses(input) ,label: input.name, type: DynamicReferenceType.CertificateMapping})">
          <icon v-if="input.parent.type === CertificateDynamicInputType.Object"glyph="infinity"></icon>
          {{input.name}}
        </button>
        <div
          v-else-if="(input.type === CertificateDynamicInputType.Repeatable)"
          class="collapse-item" :id="`element_${input.client_id}`">
          <button
            data-toggle="collapse"
            :href="`#repeatable_collapse_${input.client_id}`"
            role="button"
            :aria-expanded="isOpen([input]).toString()"
            :aria-controls="`${input.name}Collapse`"
            :class="`field-item ${{disabled: !isPresent([input]), collapsed: !isOpen([input])}}`">
            {{input.name}}
          </button>
          <div class="collapse" :class="{show: isOpen([input])}"
               :id="`repeatable_collapse_${input.client_id}`">
            <button
              v-for="(_, index) in Array(20)"
              @click="select({id: input.client_id, label: `${input.name}.${index + 1}`, index: index, type: DynamicReferenceType.CertificateMapping})"
              type="button"
              class="field-item">
              {{input.name}}.{{index + 1}}
            </button>
          </div>
        </div>
        <hr>
      </div>
    </scroll-area>
  </template>
  <template #footer>
    <button @click="createInputAndGoTo" class="btn-link btn-block">+ Add New Dynamic Input</button>
  </template>
</dynamic-fields-menu>
